import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

// College Leads API
export const scheduleCollegeDemo = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/colleges/schedule-demo`, data);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Failed to submit demo request' };
  }
};

// Mentor Applications API
export const submitMentorApplication = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/mentors/apply`, data);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Failed to submit application' };
  }
};

// Contact Inquiry API
export const submitContactInquiry = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/contact`, data);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Failed to submit inquiry' };
  }
};

// Download Tracking API
export const trackDownload = async (documentType, sourcePage, email = null) => {
  try {
    const response = await axios.post(`${API_URL}/downloads/track`, {
      document_type: documentType,
      source_page: sourcePage,
      email
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Failed to track download' };
  }
};

// Health Check
export const checkAPIHealth = async () => {
  try {
    const response = await axios.get(`${API_URL}/health`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
